/* ================================================== */
/* EMBEDS → ratio
/* ================================================== */

$(document).ready(function() {

	$('.js-ratio').each(function(i){
		var r = String($(this).attr('data-ratio')).split(':');
		$(this).attr('data-ratio', (r[1]/r[0]));
	});

});